import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  CanLoad,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Route,
  UrlTree,
} from '@angular/router';
import { XWareLogService } from '../services/xware-log.service';
import { Observable, of } from 'rxjs';
import { MsalGuard } from '@azure/msal-angular';
import { CwGapiService } from '../services/cw-gapi.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(
    private router: Router,
    private logger: XWareLogService,
    private msalguard: MsalGuard,
    private cwGapiService: CwGapiService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const url: string = state.url;
    const adType = sessionStorage.getItem('adType');
    if (adType) {
      if (adType == 'gapi') {
        if (this.cwGapiService.isUserSignedIn()) {
          return of(true);
        } else {
          this.router.navigate(['/login']);
          return of(false);
        }
      } else if (adType == 'msal') {
        return this.msalguard.canActivate(route, state);
      } else {
        this.logger.log('OTHER TYPE ' + adType);
        this.router.navigate(['/login']);
        return of(false);
      }
    } else {
      this.router.navigate(['/login']);
      return of(false);
    }
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): boolean {
    const url = `/${route.path}`;
    this.logger.log('xware01 ' + url);
    return this.checkLogin(url);
  }

  checkLogin(url: string): boolean {
    const adType = sessionStorage.getItem('adType');
    if (adType) {
      if (adType == 'gapi') {
        return this.cwGapiService.isUserSignedIn();
      } else if (adType == 'msal') {
        // Implement MSAL login check if needed
        return true;
      } else {
        this.logger.log('OTHER TYPE ' + adType);
        this.router.navigate(['/login']);
        return false;
      }
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
